import { WorkflowsEmptyState } from 'ui/illustrations';
import { NoRevisionsContainer } from './styles';

export const NO_REVISIONS_ID = 'no-revisions';

export const NoRevisions = () => {
  const noRevisionsHeader = 'No journey history yet';
  const noRevisionsMessage =
    'Whenever a draft is published, or if the journey is turned on or off, a snapshot of it is saved and will be accessible here.';
  return (
    <NoRevisionsContainer data-test={NO_REVISIONS_ID}>
      <WorkflowsEmptyState />
      <div>{noRevisionsHeader}</div>
      <div>{noRevisionsMessage}</div>
    </NoRevisionsContainer>
  );
};
